import { Field } from 'formik';
import { SttInput } from '@stt-componentes/core';
import { REQUISICAO } from '../fieldNames';

const Requisicao = ({ strings }) => {

    return (
        <Field name={REQUISICAO}>
            {({
                field
            }) => (
                <SttInput
                    {...field}
                    label={strings.requisicao}
                />
            )}
        </Field>
    );
};

export default Requisicao;